import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  Avatar,
  Menu,
  MenuItem,
} from '@mui/material';
import { Menu as MenuIcon, AccountCircle } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import LoginModal from './LoginModal';

const Header = ({ onDrawerToggle }) => {
  // Don't show header when parked
  if (process.env.REACT_APP_PARKED !== 'false') {
    return null;
  }
  
  const [anchorEl, setAnchorEl] = useState(null);
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const { user, isAuthenticated, signOut } = useAuth();

  const handleUserMenuOpen = (event) => {
    setUserMenuAnchor(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserMenuAnchor(null);
  };

  const handleLogin = () => {
    setLoginModalOpen(true);
  };

  const handleLogout = () => {
    signOut();
    handleUserMenuClose();
  };

  return (
    <>
      <AppBar position="fixed" sx={{ backgroundColor: '#89479a' }}>
        <Toolbar>
          <Button
            variant="text"
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={() => onDrawerToggle(true)}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </Button>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1 }}>
            <Typography variant="h6" noWrap component="div">
              Bloomaroot
            </Typography>
          </Box>

          {isAuthenticated ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Avatar
                src={user?.picture}
                sx={{ bgcolor: '#f78f29', cursor: 'pointer' }}
                onClick={handleUserMenuOpen}
              >
                {user?.name?.charAt(0)?.toUpperCase()}
              </Avatar>
              <Menu
                anchorEl={userMenuAnchor}
                open={Boolean(userMenuAnchor)}
                onClose={handleUserMenuClose}
              >
                <MenuItem onClick={handleUserMenuClose}>Profile</MenuItem>
                <MenuItem onClick={handleUserMenuClose}>Settings</MenuItem>
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </Box>
          ) : (<span style={{ color: 'white', cursor: 'pointer' }} onClick={handleLogin}>Login</span>)}
        </Toolbar>
      </AppBar>

      <LoginModal open={loginModalOpen} onClose={() => setLoginModalOpen(false)} />
    </>
  );
};

export default Header;
